module.exports = __webpack_public_path__ + "static/media/poicon22.fb760ad4.svg";